import React, { useState, useEffect } from "react";
import axios from "axios";
import validator from "validator";
import Layout from "./components/layout";
import Thankyou from "./container/Thankyou";
import ErrorMessage from "./container/ErrorMessage";
import Spinner from "./container/Spinner";
import Agreement from "./container/Agreement";
import { setValueToNone } from "./lib/setValueToNone";
import { deleteProperty } from "./lib/deleteProperty";
import { CREATE_API, TO_BOT } from "./globals";

import {
  corporate,
  leadership,
  multilingual,
  applicationSiteData,
  workExp,
} from "./helper/data";

const Page = ({ parsedData, initialState }) => {
  const [submit, setSubmit] = useState(false);
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const { type, dialog, application, address, status } = parsedData;

  // IF NO KYC
  const form = {
    firstName: "",
    lastName: "",
    contactNumber: "",
    email: "",
    city: "",
    applicationSite: "",
    workExperience: "",
    remarks: "",
    yearOfExperience: "",
    jobVacancy: "",
    languages: "",
    course: "",
  };

  // IF USER HAS KYC MAKE THE FIRST LETTER LOWERCASE
  const newState =
    typeof initialState["FirstName"] !== "undefined"
      ? Object.keys(initialState).reduce((newFormData, key) => {
          if (key === "EmailAddress") {
            newFormData[key[0].toLowerCase() + key.slice(1, 5)] =
              initialState[key];
          } else {
            newFormData[key[0].toLowerCase() + key.slice(1)] =
              initialState[key];
          }

          return newFormData;
        }, {})
      : form;
  // REMOVE NOT NEEDED PROPERTIES
  const newObj = deleteProperty(newState, "optin_date", "user_fb", "id");

  const loadState = () => {
    if (dialog !== "email" && typeof status !== "undefined") {
      if (status === "true") {
        return form;
      }
    }

    return newObj;
  };

  const [formData, setFormData] = useState(loadState());

  const {
    firstName,
    lastName,
    contactNumber,
    email,
    city,
    applicationSite,
    workExperience,
    remarks,
    yearOfExperience,
    jobVacancy,
    languages,
    course,
  } = formData;

  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setError(false);
      }, 4000);
    }
  }, [isError, setError]);

  const toBot = async () => {
    let data = {
      application,
      dialog,
      address: JSON.parse(address),
      formData: setValueToNone(formData),
    };
    try {
      let res = await axios.post(TO_BOT, data, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      if (res) {
        setSubmit(true);
      }
    } catch (error) {
      setError(true);
      setErrMsg("Sorry, we encountered an error. Please try again later.");
      console.error("ERROR ===> ", error);
    }
    setLoading((i) => !i);
  };

  const createKyc = async () => {
    let data = {
      application,
      dialog,
      address: JSON.parse(address),
      formData: setValueToNone(formData),
    };

    try {
      setLoading((i) => !i);
      let res = await axios.post(CREATE_API, data, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      if (res) {
        toBot();
      }
    } catch (error) {
      setLoading((i) => !i);
      setError(true);
      setErrMsg("Failure to save, check your connection.");
    }
  };

  // Call Create Kyc
  const handleSubmit = async () => {
    let regex = /^(09)\d{9}$/;
    if (firstName === "" || lastName === "" || contactNumber === "" || city === "") {
      setErrMsg("PLEASE INPUT ALL REQUIRED FIELDS BELOW");
      setError(true);
      return;
    } else if (contactNumber.match(regex) === null) {
      setErrMsg("PLEASE INPUT A VALID NUMBER");
      setError(true);
      return;
    } else if (!validator.isEmail(email)) {
      setErrMsg("PLEASE INPUT A VALID EMAIL");
      setError(true);
      return;
    }

    if (type === "leadership") {
      if (jobVacancy === "" || yearOfExperience === "") {
        setErrMsg("PLEASE INPUT ALL REQUIRED FIELDS BELOW");
        setError(true);
        return;
      }
    } else if (type === "multilingual") {
      if (jobVacancy === "" || languages === "") {
        setErrMsg("PLEASE INPUT ALL REQUIRED FIELDS BELOW");
        setError(true);
        return;
      }
    } else if (type === "corporate") {
      if (jobVacancy === "") {
        setErrMsg("PLEASE INPUT ALL REQUIRED FIELDS BELOW");
        setError(true);
        return;
      }
    } else if (type === "ojt") {
      if (course === "") {
        setErrMsg("PLEASE INPUT ALL REQUIRED FIELDS BELOW");
        setError(true);
        return;
      }
    }

    createKyc();
  };

  // onChange
  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  return submit ? (
    <Thankyou type={type} application={application} />
  ) : loading ? (
    <Spinner text="Submitting..." />
  ) : (
    <Layout type={type}>
      <>
        {isError && <ErrorMessage errMsg={errMsg} />}
        <form className="w-full max-w-lg" onSubmit={handleSubmit}>
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                First Name
                <span className="text-red-700 text-lg mr-1">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                placeholder="John"
                onChange={(e) => handleOnChange(e)}
                name="firstName"
                value={firstName}
                required
              />
            </div>
            <div className="pt-4 w-full md:w-1/2 px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Last Name
                <span className="text-red-700 text-lg mr-1">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                placeholder="Doe"
                onChange={(e) => handleOnChange(e)}
                name="lastName"
                value={lastName}
                required
              />
            </div>
          </div>

          <div className="flex flex-wrap -mx-3 mb-2">
            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Mobile Number
                <span className="text-red-700 text-lg mr-1">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                placeholder="09XX-XXX-XXXX"
                onChange={(e) => handleOnChange(e)}
                name="contactNumber"
                value={contactNumber}
                required
              />
            </div>
            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Email
                <span className="text-red-700 text-lg mr-1">*</span>
              </label>
              <input
                className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                type="email"
                placeholder="email@domain.com"
                onChange={(e) => handleOnChange(e)}
                name="email"
                value={email}
                required
              />
            </div>
            { /* Add City */}
            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Current City (e.g. Manila, Cavite, Pasig)
                <span className="text-red-700 text-lg mr-1">*</span>
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                placeholder="Manila"
                onChange={(e) => handleOnChange(e)}
                name="city"
                value={city}
                required
              />
            </div>
          
            {/* APPLICATION STATUS */}
            {dialog === "email" && type === "application_status" && (
              <>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Application Site
                  </label>
                  <div className="relative">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-state"
                      name="applicationSite"
                      value={applicationSite}
                      onChange={(e) => handleOnChange(e)}
                    >
                      <option hidden>Please Select</option>
                      {applicationSiteData.map((data, i) => (
                        <option key={i}>{data}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Remarks
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    placeholder="Remarks"
                    onChange={(e) => handleOnChange(e)}
                    name="remarks"
                    value={remarks}
                    required
                  />
                </div>
              </>
            )}
            {/* APPLY NOW */}
            {dialog === "cv" && type === "job_vacancy" && (
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Do you have any work experience?
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                    name="workExperience"
                    value={workExperience}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option hidden>Please Select</option>
                    {workExp.map((data, i) => (
                      <option key={i}>{data}</option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}
            {/* CORPORATE - CUSTOMER SERVICE */}
            {dialog === "cv" && type === "customer_service" && (
              <>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Do you have any work experience?
                  </label>
                  <div className="relative">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-state"
                      name="workExperience"
                      value={workExperience}
                      onChange={(e) => handleOnChange(e)}
                    >
                      <option hidden>Please Select</option>
                      {workExp.map((data, i) => (
                        <option key={i}>{data}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* JOB VACANCY - CORPORATE */}
            {dialog === "cv" && type === "corporate" && (
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Select Job Vacancies
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                    name="jobVacancy"
                    value={jobVacancy}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option hidden>Please Select</option>
                    {corporate.map((data, i) => (
                      <option key={i}>{data}</option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}
            {/* JOB VACANCY - LEADERSHIP */}
            {dialog === "cv" && type === "leadership" && (
              <>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Select Job Vacancies
                    <span className="text-red-700 text-lg mr-1">*</span>
                  </label>
                  <div className="relative">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-state"
                      name="jobVacancy"
                      value={jobVacancy}
                      onChange={(e) => handleOnChange(e)}
                    >
                      <option hidden>Please Select</option>
                      {leadership.map((pos, i) => (
                        <option key={i}>{pos}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Years of Experience
                    <span className="text-red-700 text-lg mr-1">*</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    placeholder="Year and Month"
                    onChange={(e) => handleOnChange(e)}
                    name="yearOfExperience"
                    value={yearOfExperience}
                    required
                  />
                </div>
              </>
            )}
            {/* JOB VACANCY - MULTILINGUAL */}
            {dialog === "cv" && type === "multilingual" && (
              <>
                <div className="w-full md:w-1/2 mb-6 px-3">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Language
                    <span className="text-red-700 text-lg mr-1">*</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    placeholder="Language"
                    onChange={(e) => handleOnChange(e)}
                    name="languages"
                    value={languages}
                    required
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Select Job Vacancies
                  </label>
                  <div className="relative">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-state"
                      name="jobVacancy"
                      value={jobVacancy}
                      onChange={(e) => handleOnChange(e)}
                    >
                      <option hidden>Please Select</option>
                      {multilingual.map((data, i) => (
                        <option key={i}>{data}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* OJT */}
            {dialog === "cv_ojt" && type === "ojt" && (
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Course
                  <span className="text-red-700 text-lg mr-1">*</span>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  type="text"
                  placeholder="Course"
                  onChange={(e) => handleOnChange(e)}
                  name="course"
                  value={course}
                  required
                />
              </div>
            )}
          </div>
          <Agreement />
          <div className="w-full md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3">
              <button
                style={{ background: "#039be5" }}
                className="shadow w-full hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="button"
                onClick={() => handleSubmit()}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </>
    </Layout>
  );
};

export default Page;
